// ATC AJAX + ouverture panier (délégation d'événements)
if (!window.cardProductInitialized) {
  window.cardProductInitialized = true;

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.js-card-atc');
    if (!btn || btn.hasAttribute('disabled') || btn.classList.contains('adding')) return;

    e.preventDefault();
    e.stopPropagation();

    const form = btn.closest('form');
    if (!form) return;

    const formData = new FormData(form);
    const originalText = btn.innerHTML;

    btn.classList.add('adding');
    btn.disabled = true;
    btn.innerHTML = '<span>Ajout...</span>';

    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');
    const cartObject = cartDrawer || cartNotification;

    if (cartObject && typeof cartObject.getSectionsToRender === 'function') {
      cartObject.getSectionsToRender().forEach(section => {
        formData.append('sections[]', section.id);
      });
      formData.append('sections_url', window.location.pathname);
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
    .then(r => {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then((data) => {
      btn.classList.remove('adding');
      btn.classList.add('added');
      btn.innerHTML = '<span>✓ Ajouté</span>';

      if (cartObject) {
        if (typeof cartObject.renderContents === 'function') {
          cartObject.renderContents(data);
        }
        
        setTimeout(() => {
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else if (cartNotification && typeof cartNotification.open === 'function') {
            cartNotification.open();
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
          }
        }, 300);
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

      setTimeout(() => {
        btn.classList.remove('added');
        btn.disabled = false;
        btn.innerHTML = originalText;
      }, 2000);
    })
    .catch((error) => {
      console.error('Erreur ajout panier:', error);
      btn.classList.remove('adding');
      btn.innerHTML = '<span>Erreur</span>';
      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = originalText;
      }, 2000);
    });
  });
}
